import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMap, FiArchive, FiUsers, FiSettings } from 'react-icons/fi';

const Sidebar: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/',
      icon: FiMap,
      label: 'Мои маршруты',
    },
    {
      path: '/?archived=true',
      icon: FiArchive,
      label: 'Архив',
    },
    {
      path: '/collaboration',
      icon: FiUsers,
      label: 'Совместная работа',
    },
    {
      path: '/profile',
      icon: FiSettings,
      label: 'Настройки',
    },
  ];

  return (
    <aside className="sidebar hidden lg:block">
      <div className="p-6">
        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
                           (item.path === '/?archived=true' && location.search.includes('archived=true'));

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar; 